import { isMobile } from "react-device-detect";
import organizationIcon from "../../assets/icons/organization-icon.svg";
import { useProjects, useScope } from "../../container/SelectProjectCompanyContainer";
import { CheckBox } from "../Form";

const CompanyMenu = ({ organizations, openModalProject, collapsed, openCompanyMenu, assistanceScreen }) => {
  const { scope } = useScope();
  const { changeScope } = useProjects(assistanceScreen);

  const handleSelectGroup = (value) => {
    changeScope(value, 'organization');
  }

  return (
    <div className={`company-menu-container ${collapsed ? "company-menu-container--invisible" : ""} ${openCompanyMenu ? "company-menu-container--active" : "company-menu-container--inactive"} `}>
      <div className="company-menu__labels">
        <span>ORGANIZAÇÃO</span>
        <span>EMPRESAS</span>
      </div>
      <div className="company-menu__content">
        <ul>
          {Array.isArray(organizations) && organizations.map(organization => {
            return (
              <li key={organization?.id}>
                <div
                  className="company-menu__content-labels"
                >
                  {isMobile ? (
                    <></>
                  ) : (
                    <CheckBox
                      type="checkbox"
                      checked={scope?.id === organization?.id}
                      onChange={() => handleSelectGroup(organization?.id)}
                      disabled={!organization.id}
                    />)}
                  <div className="company-menu__content-labels-image" onClick={() => openModalProject(organization.companies, organization?.name)}>
                    <img src={organizationIcon} />
                  </div>
                  <div
                    className="company-menu__content-labels-title"
                    title={organization?.name}
                    onClick={() => openModalProject(organization.companies, organization?.name)}
                  >
                    {organization?.name}
                  </div>
                  <div className={`company-menu__content-labels-count-project ${window.scrollY}`}>
                    {organization.companies?.length || 0}
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default CompanyMenu
